import {Component, Inject, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UrlUtils} from '../../utils/url.utils';
import {ConfigurationService} from "../../services/configuration.service";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  @Input('pages') pages = [];
  regions = [];
  arcs = [];

  private defaultRegion;
  private defaultArc;


  constructor(
    private readonly router: Router,
    @Inject('UrlUtils') private readonly urlUtils: UrlUtils,
    @Inject('ConfigurationService') private readonly configurationService: ConfigurationService
  ) {
    configurationService.getSettings().subscribe(settings => {
      this.defaultRegion = settings.defaultRegion;
this.defaultArc = settings.defaultArc;

      this.regions = settings.regions;
      this.defaultArc = settings.defaultArc;
      this.arcs = settings.arcs;
    });
  }

  ngOnInit() {
  }

  clickRegionButton(region: string) {
    location.href = this.urlUtils.setSearchParam(location.href, 'region', region);
  }

  getRegion() {
    return this.urlUtils.getSearchParam(location.href, 'region', this.defaultRegion);
  }

  clickArcButton(arc: string) {
    location.href = this.urlUtils.setSearchParam(location.href, 'arc', arc);
  }

  getArc() {
    return this.urlUtils.getSearchParam(location.href, 'arc', this.defaultArc);
  }
}
